module.exports = __webpack_public_path__ + "static/media/carrorama-video-numeros.bb6bcb3d.png";